import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";
import type {Dispatch} from "redux";

import type {IFetchContext} from "@pg-mono/data-fetcher";
import {createRequestActionTypes} from "@pg-mono/request-state";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import type {IAveragePricesQuery} from "../types/IAveragePricesQuery";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";
import {fetchAveragePricesBySlug} from "./fetch_average_prices";

const FETCH_REPORT_PRICE_ALL_CITIES_PRICES = "reports/FETCH_REPORT_PRICE_ALL_CITIES_PRICES";

export const fetchReportPriceAllCitiesPrices = createRequestActionTypes(FETCH_REPORT_PRICE_ALL_CITIES_PRICES);

export const fetchAllCitiesPrices = (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
    dispatch({type: fetchReportPriceAllCitiesPrices.start});

    const pricesAvailableDate = getState().report.price.pricesAvailableDate;

    const date = getPricesAvailableDate(pricesAvailableDate?.date);

    const query: IAveragePricesQuery = {
        // First day of month, 6 months ago, format yyyy-mm-dd
        date_start: formatISO(sub(setDate(date, 1), {months: 1}), {representation: "date"}),
        // Last day of month before date, format yyyy-mm-dd
        date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
        scenario: "rp-avg",
        offer_type: getTypeForFetch(PricesViewType.FLATS),
        slug_city: "all"
    };

    const prices = await fetchAveragePricesBySlug(query);

    if (prices) {
        dispatch({type: fetchReportPriceAllCitiesPrices.success, result: prices});

        return prices;
    }

    dispatch(rpEnable404ResponseState(ctx.route.pathname));

    return false;
};
import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";
import type {Dispatch} from "redux";

import type {IFetchContext} from "@pg-mono/data-fetcher";
import {createRequestActionTypes} from "@pg-mono/request-state";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import type {IAveragePricesQuery} from "../types/IAveragePricesQuery";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";
import {fetchAveragePricesBySlug} from "./fetch_average_prices";

const FETCH_REPORT_PRICE_ALL_CITIES_PRICES = "reports/FETCH_REPORT_PRICE_ALL_CITIES_PRICES";

export const fetchReportPriceAllCitiesPrices = createRequestActionTypes(FETCH_REPORT_PRICE_ALL_CITIES_PRICES);

export const fetchAllCitiesPrices = (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
    dispatch({type: fetchReportPriceAllCitiesPrices.start});

    const pricesAvailableDate = getState().report.price.pricesAvailableDate;

    const date = getPricesAvailableDate(pricesAvailableDate?.date);

    const query: IAveragePricesQuery = {
        // First day of month, 6 months ago, format yyyy-mm-dd
        date_start: formatISO(sub(setDate(date, 1), {months: 1}), {representation: "date"}),
        // Last day of month before date, format yyyy-mm-dd
        date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
        scenario: "rp-avg",
        offer_type: getTypeForFetch(PricesViewType.FLATS),
        slug_city: "all"
    };

    const prices = await fetchAveragePricesBySlug(query);

    if (prices) {
        dispatch({type: fetchReportPriceAllCitiesPrices.success, result: prices});

        return prices;
    }

    dispatch(rpEnable404ResponseState(ctx.route.pathname));

    return false;
};
